/**
 * The templateMapper folder is copied as-is from composition-api.
 * WARNING: Any updates made to templateMapper in composition-api,
 * should be copied here as well for the time being
 * Refer: https://gitlab.nordstrom.com/cxa/digital-assembly/composition-api
 */

// Supported Placements
const HP_TOP_BANNER = 'HP - P00 Banner';
const HP_HERO = 'HP - Default Hero';
const RESPONSIVE_CAROUSEL = 'Responsive Carousel';
const IN_YOUR_BAG = 'In Your Bag';
const LOOKS_REC_TRAY = 'Looks Rec Tray';
const RECOMMENDATION_SHELF = 'Recommendation Shelf';
const HP_RANKED_RESULTS = 'HP Ranked Results';
const PROMO_TILE = 'PromoTile';
const HP_SERVICES = 'HP - Services';
const MORE_TO_EXPLORE = 'More to Explore';
const PHP_TILE_PREVIEW = 'PHP Tile Preview';
const REMAINING_COMPONENTS = 'Remaining Components';

// Other Schema Names
const STORY_CAROUSEL = 'Story Carousel';
const PHP_TILE = 'Personalized HP Tile';

module.exports = {
  // Supported Placements
  HP_TOP_BANNER,
  HP_HERO,
  RESPONSIVE_CAROUSEL,
  IN_YOUR_BAG,
  LOOKS_REC_TRAY,
  HP_RANKED_RESULTS,
  PROMO_TILE,
  HP_SERVICES,
  MORE_TO_EXPLORE,

  // Other Schema Names
  RECOMMENDATION_SHELF,
  STORY_CAROUSEL,
  PHP_TILE,
  PHP_TILE_PREVIEW,
  REMAINING_COMPONENTS
};
